// extracted by mini-css-extract-plugin
export default {"taxFeeContainer":"xQK_jb"};